import { AlertTitle as AlertTitleLibrary } from '@mui/material';
import { type PropsWithChildren } from 'react';

type P = PropsWithChildren & ComponentStyling;

export const AlertTitle = ({ children, className, style }: P) => (
  <AlertTitleLibrary classes={{ root: className }} style={style}>
    {children}
  </AlertTitleLibrary>
);
